export default function formatDate(dateString) {
    const date = new Date(dateString);
    const mm = ('0' + (date.getMonth()+1)).slice(-2);
    const dd = ('0' + date.getDate()).slice(-2);
    const yy = date.getFullYear();

    return yy + '-' + mm + '-' + dd;
}
